export const genericMessages = {
  unexpected:
    'Întâmpinăm o problemă tehnică. Te rugăm să reîncerci. Dacă problema persistă, contactează echipa de suport.',
};

export const phoneOtpMessages = {
  invalid_code:
    'Codul pe care încerci să-l introduci nu este valid. Asigără-te că introduci corect codul primit prin SMS.',
  limit_exceeded:
    'Ai ajuns la limita de încercări. Te rugăm să încerci mai târziu.',
  invalid_phone_number:
    'Ai introdus un număr de telefon greșit. Te rugăm să încerci din nou.',
  unexpected: genericMessages.unexpected,
};

export const emailMessages = {
  invalid_email:
    'Email-ul nu este valid. Asigură-te că introduci un email valid.',
  email_exists: 'Acest email nu poate fi utilizat. Încearcă alt email.',
  unexpected: genericMessages.unexpected,
};

export const emailOtpMessages = {
  limit_exceeded:
    'Ai ajuns la limita de încercări. Te rugăm să încerci mai târziu.',
  invalid_code:
    'Codul pe care încerci să-l introduci nu este valid. Asigără-te că introduci corect codul primit prin email.',
  unexpected:
    'Întâmpinăm o problemă tehnică. Te rugăm să reîncerci. Dacă problema persistă, contactează echipa de suport.',
};

export const bcPhoneMessages = {
  invalid_code: phoneOtpMessages.invalid_code,
  limit_exceeded: phoneOtpMessages.limit_exceeded,
  sms_failed: 'Nu am putut trimite SMS-ul. Te rugăm să încerci din nou.',
  unexpected: genericMessages.unexpected,
};

export const cnpMessages = {
  invalid_cnp: 'Acest CNP nu poate fi utilizat.',
  invalid_format: 'CNP-ul nu este valid. Te rugăm să verifici din nou.',
};

export const loanSignMessages = {
  otp_rate_limited:
    'Ți-am trimis deja un cod. Folosește codul primit prin SMS sau cere altul când se termină timpul.',
  invalid_otp:
    'Codul pe care încerci să-l introduci nu este valid. Asigără-te că introduci corect codul primit prin email.',
  unexpected: genericMessages.unexpected,
};
